<template>
  <dx-popup
    :visible="localVisible"
    title="Add Product"
    :show-title="true"
    width="600px"
    height="auto"
    @update:visible="updateVisible"
  >
    <DxForm ref="newProduct" validation-group="productForm" :form-data="product">
      <DxSimpleItem
        dataField="name"
        :editorOptions="{
          placeholder: 'Product Name',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
        :validationRules="[{ type: 'required', message: 'Name is required!' }]"
      />
      <DxSimpleItem
        dataField="description"
        :editorOptions="{
          placeholder: 'Product Description',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
        :validationRules="[{ type: 'required', message: 'Description is required!' }]"
      />
   
      <DxSimpleItem
        dataField="price"
        editorType="dxNumberBox"
        :editorOptions="{
          placeholder: 'Price',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' },
          format: '#,##0',
          showSpinButtons: true
        }"
        :label="{ visible: false }"
        :validationRules="[{ type: 'required', message: 'Price is required!' }]"
      />
      <DxSimpleItem
        dataField="category_id"
        :editorType="'dxSelectBox'"
        :editorOptions="{
          dataSource: categories,
          displayExpr: 'name',
          valueExpr: 'id',
          value: selectedCategory,
          onValueChanged: (e) => { this.selectedCategory = e.value; }, // Update selectedCategory on change
          placeholder: 'Select Category',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
        :validationRules="[{ type: 'required', message: 'Category is required!' }]"
      />
      <DxButtonItem
        :buttonOptions="{
          text: 'Cancel',
          type: 'normal',
          onClick: cancel,
          width: '100px'
        }"
      />
      <DxButtonItem
        :buttonOptions="{
          text: 'Save',
          type: 'success',
          onClick: saveProduct,
          width: '100px'
        }"
      />
    </DxForm>
  </dx-popup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxForm, DxSimpleItem, DxButtonItem } from 'devextreme-vue/form';
import validationEngine from 'devextreme/ui/validation_engine';
import notify from 'devextreme/ui/notify';

export default {
  components: {
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxButtonItem
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      localVisible: this.visible,
      product: {
        name: '',
        description: '',
        price: null,
        category_id: null,
        created: null // Add this line
      },
      categories: [],
      selectedCategory: null // Add this line
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
      if(newVal) {
        this.fetchCategories();
      }
    }
  },
  created() {
    this.fetchCategories();
  },
  methods: {
    updateVisible(newVal) {
      this.$emit('update:visible', newVal);
    },
    saveProduct() {
      // Validate the form before saving
      const result = validationEngine.validateGroup('productForm');

      if (result.isValid) {
        // Set the selected category to the product object
        this.product.category_id = this.selectedCategory;

        // Set the created field to the current date and time
        this.product.created = this.formatDate(new Date());
        
        // Log the product object to verify values
        //console.log('Product to be saved:', this.product);

        // Logic to save the product
        fetch(`${process.env.VUE_APP_API_URL}/product/create.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.product)
        })
        .then(response => {
          if (!response.ok) {
            return response.text().then(text => { throw new Error(text); });
          }
          return response.json();
        })
        .then(data => {
          console.log('Product saved:', data);
          this.$emit('save', this.product);
          this.updateVisible(false);
          
          // Notify the user that the product has been saved
          notify(`Product saved with ID: ${data.id}`, 'success', 3000);
          this.resetForm();
        })
        .catch(error => {
          console.error('Error saving product:', error);
        });
      }
    },
    cancel() {
      this.updateVisible(false);
    },
    fetchCategories() {
      fetch(`${process.env.VUE_APP_API_URL}/category/read.php`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => { throw new Error(text); });
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched categories:', data);
        this.categories = data.records;
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
    },
    formatDate(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    const hours = ('0' + d.getHours()).slice(-2);
    const minutes = ('0' + d.getMinutes()).slice(-2);
    const seconds = ('0' + d.getSeconds()).slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
   },
   resetForm() {
      this.product = {
        name: '',
        description: '',
        price: null,
        category_id: null,
        created: null,
        selectedCategory: null
      };
    }
  }
};
</script>

<style scoped>
.form-popup-buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
/* Add your styles here */
</style>